// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ThunderboltTwoToneSvg from "@ant-design/icons-svg/es/asn/ThunderboltTwoTone";
import AntdIcon from '../components/AntdIcon';

var ThunderboltTwoTone = function ThunderboltTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltTwoToneSvg
  }));
};

ThunderboltTwoTone.displayName = 'ThunderboltTwoTone';
export default React.forwardRef(ThunderboltTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ThunderboltTwoTone.js
// module id = 1937
// module chunks = 0